// extracted by mini-css-extract-plugin
export default {"clubContainer":"Club_clubContainer__5VWYK","imageContainer":"Club_imageContainer__Y9KbH","infoContainer":"Club_infoContainer__Td1lb"};